<template>
    <div class="account-picker-action-buttons">
        <button class="btn btn-sm btn-outline" tabindex="-1" @click="showNewBookkeepingAccountPopup">
            <i class="i-ph-list-plus block"/> Ny konto
        </button>
        <button class="btn btn-sm btn-outline" tabindex="-1" @click="showNewCustomerPopup">
            <i class="i-ph-user-plus-fill block"/> Ny kunde
        </button>
        <button class="btn btn-sm btn-outline" tabindex="-1" @click="showNewSupplierPopup">
            <i class="i-ph-truck-fill block"/> Ny leverandør
        </button>
    </div>
</template>

<script setup lang="ts">
import {CUSTOMER, SubAccount, SubAccountRelationType, SUPPLIER} from '@/subaccount/types/SubAccount'
import NewSubAccountPopup from '@/subaccount/NewSubAccountPopup.vue'
import NewBookkeepingAccountPopup from '@/bookkeeping-account/NewBookkeepingAccountPopup.vue'
import {CUSTOMER_ACCOUNT_NO, SUPPLIER_ACCOUNT_NO} from '@/bookkeeping-account/accountTypes'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'
import useDynamicComponentLoader from '@/dynamic-component-loader/dynamicComponent.service'

const {loadComponent, clearDynamicComponent} = useDynamicComponentLoader()

const props = defineProps({
    searchText: {type: String, default: ''}
})

const emit = defineEmits(['created', 'hidePicker'])

const hideAccountPicker = () => emit('hidePicker')

const showNewSubAccountPopup = (relationType: SubAccountRelationType) => {
    hideAccountPicker()

    loadComponent(
        NewSubAccountPopup,
        {
            relationType,
            name: props.searchText
        },
        {
            created: (sacc: SubAccount) => {
                const prefix = sacc.relationType === CUSTOMER ? CUSTOMER_ACCOUNT_NO : SUPPLIER_ACCOUNT_NO
                emit('created', `${prefix}:${sacc.subAccountNo}`)
            },
            close: () => {
                clearDynamicComponent()
            }
        }
    )
}

const showNewBookkeepingAccountPopup = () => {
    hideAccountPicker()

    const isNumber = /^\d+$/.test(props.searchText)
    const popupProps = isNumber ? {} : {name: props.searchText}

    loadComponent(
        NewBookkeepingAccountPopup,
        popupProps,
        {
            created: (bkacc: BookkeepingAccount) => {
                emit('created', bkacc.accountNo)
            },
            close: () => {
                clearDynamicComponent()
            }
        }
    )
}

const showNewCustomerPopup = () => showNewSubAccountPopup(CUSTOMER)
const showNewSupplierPopup = () => showNewSubAccountPopup(SUPPLIER)

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.account-picker-action-buttons {
    @apply flex justify-end gap-1 m-1;

    button {
        @apply grow;
    }
}
</style>